import { render, staticRenderFns } from "./QuizEditor.vue?vue&type=template&id=07283afa&scoped=true"
import script from "./QuizEditor.vue?vue&type=script&lang=js"
export * from "./QuizEditor.vue?vue&type=script&lang=js"
import style0 from "./QuizEditor.vue?vue&type=style&index=0&id=07283afa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07283afa",
  null
  
)

export default component.exports